(function(){
    'use strict'

    angular.module('app.reportes')
    .factory('ReportesService', ReportesService);

    ReportesService.$inject = ['$http', 'apiSettings', 'UserInfoService'];

    function ReportesService($http, apiSettings, UserInfoService) {

        var api = {
            getGeneralPlanilla:getGeneralPlanilla,
            getPrevioPlanilla: getPrevioPlanilla,
            getPrevioDetalladoPlanilla: getPrevioDetalladoPlanilla,
            getGeneralDetalladoPlanilla: getGeneralDetalladoPlanilla,
            getBancarioBNCR: getBancarioBNCR,
            getLibroSalarios: getLibroSalarios,
            getArchivoAsociacionSolidarista: getArchivoAsociacionSolidarista,
            getHistoricoSalarios: getHistoricoSalarios,
            getVacaciones: getVacaciones,
            getAsientos: getAsientos,
            getArchivoGrandesContribuyentes: getArchivoGrandesContribuyentes,
            getPlanillaPorCC: getPlanillaPorCC
        };

        return api;

        function getGeneralPlanilla(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/reportes/general/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getPrevioPlanilla(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/reportes/previo/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getPrevioDetalladoPlanilla(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/reportes/previo-detallado/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getGeneralDetalladoPlanilla(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/reportes/cerrado-detallado/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getBancarioBNCR(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/reportes/bancario-bncr/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getLibroSalarios(tipoPlanilla, fechaInicio, fechafinal, enAsociacion){

            var url = apiSettings.apiBaseUrl + 'api/reportes/libro-salarios/' + UserInfoService.getCompaniaId() + '/' + tipoPlanilla + '/' + fechaInicio + '/' + fechafinal + '/' + enAsociacion;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getArchivoAsociacionSolidarista(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/reportes/archivo-asociacion/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getHistoricoSalarios(tipoPlanilla, empleadoId, periodoInicio, periodoFin){

            empleadoId = empleadoId == '' ? -1 : empleadoId;
            var url = apiSettings.apiBaseUrl + 'api/reportes/historico-salarios/' + UserInfoService.getCompaniaId() + '/' + tipoPlanilla + '/' + empleadoId + '/' + periodoInicio + '/' + periodoFin;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getVacaciones(tipoPlanilla, empleadoId){

            empleadoId = empleadoId == '' ? -1 : empleadoId;
            var url = apiSettings.apiBaseUrl + 'api/reportes/vacaciones/' + UserInfoService.getCompaniaId() + '/' + tipoPlanilla + '/' + empleadoId;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getAsientos(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/reportes/asientos/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getArchivoGrandesContribuyentes(anno, mes){

            var url = apiSettings.apiBaseUrl + 'api/reportes/archivo-grandes-contribuyentes/' + UserInfoService.getCompaniaId() + '/' + anno + '/' + mes;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];
    
                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

        function getPlanillaPorCC(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/reportes/planilla-por-cc/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };
    };

})();